// extracted by mini-css-extract-plugin
export default {"modal":"InterviewProcessModal_modal__MDMyZ","interview-note":"InterviewProcessModal_interview-note__NmIyZ"};